import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { ConvertService } from 'src/app/services/convert.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { ResourceStore } from 'src/app/stores/resources/resource.store';
import { DataService } from 'src/app/services/data.service';
import { FireValidatorsService } from 'src/app/services/fire-validators.service';
import { IGrammarInUse } from 'src/app/interfaces/resource';
import { STATUS_OBJECT, DISPLAY_STATUS_OBJECT } from 'src/app/dummy/status';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { GrammarInUseStore } from 'src/app/stores/resources/grammarInUse';

@Component({
  selector: 'app-grammar-section-form',
  templateUrl: './grammar-section-form.component.html',
  styleUrls: ['./grammar-section-form.component.scss']
})
export class GrammarSectionFormComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  LESSON_KEY: any;
  ITEM_KEY: any;
  ITEM: IGrammarInUse;
  LESSON: any;
  TITLE: any = "Add new grammar section"

  form: FormGroup;
  name: AbstractControl;
  description: AbstractControl;
  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  LOADING = true;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthStore,
    public store: ResourceStore,
    public ds: DataService,
    private snackBar: MatSnackBar,
    private storage: FireStorageService,
    public grammar: GrammarInUseStore
  ) { }


  async ngOnInit() {
    this.form = this.fb.group({
      name: [null, Validators.required, FireValidatorsService.checkExistByCompany(this.ds.firestoreRef(), this.auth.selectedCompanyKey, COLLECTION_NAME.GRAMMAR_IN_USE, "name")],
      description: [null],
    })
    this.route.params.subscribe(async param => {
      const { id, lessonKey } = param;
      this.LESSON_KEY = lessonKey
      this.LESSON = await this.grammar.fetchSelectedLesson(lessonKey)
      if (!this.LESSON) {
        this.router.navigate([`/404`])
        return;
      }
      if (id !== 'draft') {
        this.ITEM_KEY = param.id;
        this.store.fetchSelectedData(COLLECTION_NAME.GRAMMAR_IN_USE, this.ITEM_KEY, (doc: IGrammarInUse) => {
          if (doc) {
            this.TITLE = "Edit grammar section"
            this.ITEM = doc;
            this.form = this.fb.group({
              name: [null, Validators.required, FireValidatorsService.checkExistByCompany(this.ds.firestoreRef(), this.auth.selectedCompanyKey, COLLECTION_NAME.LESSON, "name", this.ITEM.name)],
              description: [null],
            })
            const { name, description, } = doc;
            this.form.patchValue({
              name, description
            })
            this.inputEl.nativeElement.focus();
            this.LOADING = false;
            return;
          }
          else {
            this.ITEM = null;
            this.router.navigate([`/grammar-in-use/lesson/${this.LESSON_KEY}`])
          }
        })
      }
      else {
        this.ITEM = null;
        this.ITEM_KEY = null;
        this.LOADING = false;
      }
    })
  }

  async onSave(f: any, isDraft: boolean) {
    if (this.form.valid) {
      this.processClose = isDraft ? false : true;
      this.processNew = isDraft;
      this.error = null;
      this.form.disable();
      const { name, description } = f;
      const { user, selectedCompanyKey } = this.auth;
      const registerStatus = isDraft ? STATUS_OBJECT.draft : STATUS_OBJECT.submitted;
      const key = this.ITEM ? this.ITEM.key : this.ds.createId();

      const item: IGrammarInUse = {
        key: key,
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: this.ITEM ? this.ITEM.created_at : new Date(),
        created_by: this.ITEM ? this.ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: ConvertService.toCapitalize(`${name.trim()}`),
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: selectedCompanyKey,
        created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        name: name.trim(),
        description,
        section: true,
        lessonKey: this.LESSON_KEY,
        lessonRef:this.ds.grammarInUseRef().doc(this.LESSON_KEY).ref
      }
      this.store.addItem(COLLECTION_NAME.GRAMMAR_IN_USE, item, (success, res) => {
        if (success) {
          this.snackBar.open("Grammar in Use has been saved successful.", "Done", { duration: 2500 });
          this.form.reset();
        }
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.inputEl.nativeElement.focus();
        if (this.ITEM_KEY) {
          this.router.navigate([`/grammar-in-use/lesson/${this.LESSON_KEY}`])
        }
      })
    }
    else {
      this.inputEl.nativeElement.focus();
      this.processNew = false;
      this.processClose = false;
    }
  }

  goBack() {
    this.router.navigate([`/grammar-in-use/lesson/${this.LESSON_KEY}`])
  }

}
